import appReducer from './app/reducer';
import { STATE_NAME as APP_STATE_NAME } from './app/constants';
import loginReducer from './loginSystem/reducer';
import { STATE_NAME as LOGIN_SYSTEM_STATE_NAME } from './loginSystem/constants';
import notificationReducer from './notificationSystem/reducer';
import { STATE_NAME as NOTIFICATION_STATE_NAME } from './notificationSystem/constants';
import alertSystemReducer from './alertSystem/reducer';
import { STATE_NAME as ALERT_SYSTEM_STATE_NAME } from './alertSystem/constants';
import ppiReducer from './PpiContainer/reducer';
import { STATE_NAME as PPI_STATE_NAME } from './PpiContainer/constants';
import ppsiReducer from './PpsiContainer/reducer';
import { STATE_NAME as PPSI_STATE_NAME } from './PpsiContainer/constants';
import dishReducer from './DishContainer/reducer';
import { STATE_NAME as DISH_STATE_NAME } from './DishContainer/constants';
import ingredientReducer from './IngredientContainer/reducer';
import { STATE_NAME as INGREDIENT_STATE_NAME } from './IngredientContainer/constants';
import ingredientEntryReducer from './IngredientEntryContainer/reducer';
import { STATE_NAME as INGREDIENT_ENTRY_STATE_NAME } from './IngredientEntryContainer/constants';
import utensilReducer from './UtensilContainer/reducer';
import { STATE_NAME as UTENSIL_STATE_NAME } from './UtensilContainer/constants';
import feedbackreducer from './FeedbackContainer/reducer';
import { STATE_NAME as FEEDBACK_STATE_NAME } from './FeedbackContainer/constants';
import { STATE_NAME as MARKET_SETTINGS_NAME } from './MarketSettingContainer/constants';
import marketSettingsReducer from './MarketSettingContainer/reducer';

export default {
  [APP_STATE_NAME]: appReducer,
  [LOGIN_SYSTEM_STATE_NAME]: loginReducer,
  [NOTIFICATION_STATE_NAME]: notificationReducer,
  [ALERT_SYSTEM_STATE_NAME]: alertSystemReducer,
  [PPI_STATE_NAME]: ppiReducer,
  [PPSI_STATE_NAME]: ppsiReducer,
  [DISH_STATE_NAME]: dishReducer,
  [INGREDIENT_STATE_NAME]: ingredientReducer,
  [INGREDIENT_ENTRY_STATE_NAME]: ingredientEntryReducer,
  [UTENSIL_STATE_NAME]: utensilReducer,
  [FEEDBACK_STATE_NAME]: feedbackreducer,
  [MARKET_SETTINGS_NAME]: marketSettingsReducer
};
